import request from '@/utils/request'
import axios from "axios"
const ajax = {
    // 需方首页供方店铺搜索
    MallStore(jsonStr = {}) {

        let params = encodeURI(JSON.stringify(jsonStr.jsonStr||{}));

        return request.post(`/mall/mallmanage/index/queryIndexProviderMallStore?pageSize=${jsonStr.pageSize||10}&pageNo=${jsonStr.pageNo||1}&jsonStr=${params}`)
    },
// 店铺ID信息
    MallStoreNavigation(id){
        return request.post(`/mall/storemanage/mallstore/queryMallStoreNavigation?FMallStoreId=${id}&FTemplateId=0`)
  
    },
    // 供方店铺搜索页 区域
    WebArea(){
        return request.get(`/mall/mallmanage/index/queryAllProvinceFromWebArea`);
    }
   
}

export default ajax